<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5 left-content" style="padding-bottom: 0!important;">
        <div class="w-100 align-items-center justify-content-center px-5" style="color: white">
          <div class=" d-none d-block d-lg-flex align-items-center justify-content-center">
            <div class="d-none d-block" style="width: 630px">
              <b-row>
                <span class="font-large-4 font-weight-bolder">80%</span>
              </b-row>
              <b-row>
                <span class="font-medium-2 mt-1">
                  Các cuộc thảo luận về thương hiệu<br/>của bạn xảy ra bên ngoài kênh riêng<br/> của bạn.
                </span>
              </b-row>
              <b-row>
                <span class="font-medium-2 mb-2 mt-2">
                  Cùng <b>InfoCare</b> khám phá những dữ <br/> liệu internet bạn chưa biết tới.
                </span>
              </b-row>
            </div>
          </div>

          <div class="d-lg-flex align-items-center justify-content-center">
            <b-img
              fluid
              src="@/assets/images/logo/bg-forgot-email.png"
              style="width: 630px;height: 400px;"
              alt="Login V2"/>
          </div>

        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-3">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div class="d-flex mb-2">
            <img src="@/assets/images/pages/base-logo.png">
            <h1 class="text-left text-title mt-1">InfoCare</h1>
          </div>
          <b-card-text class="mb-3">
            <h4>Đặt mật khẩu mới</h4>
            Mật khẩu mới nên khác với các mật khẩu đã dùng.
          </b-card-text>
          <validation-observer
            ref="forgotPasswordForm"
            #default="{invalid}">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="forgotPassword">
              <!-- password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="password">Mật khẩu</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="password"
                  vid="password"
                  rules="required|min:6">
                  <b-form-input
                    id="password"
                    v-model="user.password"
                    :state="errors.length > 0 ? false:null"
                    name="password"
                    placeholder=""
                    :type="passwordFieldType"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- confirm password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="rePassword">Xác nhận mật khẩu</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="rePassword"
                  vid="rePassword"
                  :rules="isSendMail > 0 ? { is: user.rePassword, min:6 } : {required: true, is: user.password, min: 6} ">
                  <b-form-input
                    id="confirm-password"
                    v-model="user.rePassword"
                    :state="errors.length > 0 ? false:null"
                    name="rePassword"
                    placeholder=""
                    :type="passwordFieldType"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid">Đổi mật khẩu mới</b-button>
            </b-form>
          </validation-observer>
          <div class="vx-row">
            <vs-button type="flat" class="w-full" icon-pack="feather" icon="icon-chevron-left" to="/pages/login">Quay lại trang đăng nhập</vs-button>
          </div>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>
<script src="https://apis.google.com/js/platform.js" async defer></script>
<script>
/* eslint-disable global-require */
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
} from 'bootstrap-vue'
import {togglePasswordVisibility} from '@core/mixins/ui/forms'
import GoogleLogin from 'vue-google-login';
import GoogleSignInButton from 'vue-google-signin-button-directive'

export default {
  directives: {
    GoogleSignInButton
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    GoogleLogin
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      isSendMail: 0,
      email: '',
      user: {
        password: null,
        rePassword: null
      }
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  created() {
    this.user.email = this.$route.query.email;
    this.user.otp = this.$route.query.otp
  },
  methods: {
    async forgotPassword(evt) {
      const result = await this.$refs.forgotPasswordForm.validate();
      if (!result) return;
      if (!this.user.password || !this.user.rePassword){
        return this.$vs.notify({
          text: "Password chưa được nhập.",
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }
      this.$vs.loading();
      this.$oauth.post("/registration/forgot-password", this.user).then((res) => {
        
        return this.$vs.notify({
          text: "Cập nhật mật khẩu thành công",
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'primary'
        });
      }).catch((err) => {
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      }).finally(() => {
        this.$vs.loading.close();
      })
    }
  },
}
</script>
<style lang="scss">
@import 'src/@core/scss/vue/pages/page-auth.scss';
</style>
<style lang="scss" scoped>
@import 'src/@core/scss/core.scss';
</style>
